export function makePageSingleton<I, A>(
  createInstance: (...args: A[]) => I
): (...args: A[]) => I {
  let instance: I | null

  const resetInstance = (): void => {
    if (
      instance &&
      typeof instance === 'object' &&
      'teardown' in instance &&
      typeof instance.teardown === 'function'
    ) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      instance.teardown()
    }
    instance = null
  }

  // Reset instance when Turbolinks navigates to a new page
  window.addEventListener('turbolinks:before-visit', resetInstance)
  // Reset instance when navigates back/forward in a browser
  window.addEventListener('popstate', resetInstance)

  const setupInstance = (...args: A[]): I => {
    instance = createInstance(...args)
    return instance
  }

  const getInstance = (...args: A[]): I => {
    return instance ? instance : setupInstance(...args)
  }

  return getInstance
}
